// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"1648":"91c43e63","5778":"75978aae"}[chunkId] + ".chunk.min.js";
};